/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDynamicForm = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        clipRule="evenodd"
        d="M9 2H8v6h14V2h-1zm1 4V4h10v2zM2 6h4V4H2zm7 3H8v6h7v-2h-5v-2h12V9zm-7 4h4v-2H2zm7 3H8v6h7v-2h-5v-2h5v-2zm-7 4h4v-2H2zm14.167-3.417L19.917 12l-.834 3.75L22 17l-5 5 2.083-4.167z"
        fill="currentcolor"
        fillRule="evenodd"
      />
    </g>
  </Icon>
);
export { SvgDynamicForm as DynamicForm };
